import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import '../styles/MatchingFlow.css';
import DangerIcon from '../assets/modal-icon-danger.png';

export default function MatchingFlow() {
  const navigate    = useNavigate();
  const { user_id } = useParams();
  const { state }   = useLocation();
  const expired     = state?.expired;

  const [showModal, setShowModal]       = useState(false);
  const [modalMessage]                  = useState(
    'Your free trial has expired. Please select a plan below to continue.'
  );
  const [selectedPlan, setSelectedPlan] = useState('trial');
  const [canTrial, setCanTrial]         = useState(true);

  // Show the “expired” modal on mount if flagged
  useEffect(() => {
    if (expired) setShowModal(true);
  }, [expired]);

  // Fetch their subscription so we can grey-out trial if they've used it
  useEffect(() => {
    fetch(
      `https://api.bestday2marry.com/account_status/?user_id=${user_id}`,
      { method: 'GET', credentials: 'include' }
    )
      .then(res => res.json())
      .then(({ account_status }) => {
        const plan = account_status.subscription?.plan;
        // if they've ever been on trial, disable it
        if (plan === 'trial') {
          setCanTrial(false);
          // switch default to something they can actually pick
          setSelectedPlan('standard');
        }
      })
      .catch(err => console.error('account_status fetch failed', err));
  }, [user_id]);

  const handlePlanChange = (e) => {
    setSelectedPlan(e.target.value);
  };

  const handleCheckout = async () => {
    try {
      const response = await fetch(
        `https://api.bestday2marry.com/stripe_session?user_id=${user_id}&plan=${selectedPlan}&account_type=couple`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ plan: selectedPlan }),
        }
      );
      const sessionData = await response.json();
      if (sessionData.status === 'success' && sessionData.checkoutUrl) {
        window.location.href = sessionData.checkoutUrl;
      } else {
        console.error('Failed to create a Stripe checkout session.');
      }
    } catch (error) {
      console.error('Error creating Stripe session:', error);
    }
  };

  return (
    <>
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <img src={DangerIcon} alt="Danger" className="danger-icon" />
            <p>{modalMessage}</p>
            <button
              className="modal-button"
              onClick={() => setShowModal(false)}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <div className="matching-flow-container">
        <header className="logo">
          <a href="/">BestDay2Marry</a>
        </header>
        <main>
          <h1>Wedding Matching Process</h1>
          <p>Select your subscription plan to get started:</p>
          <form>
            <fieldset>
              <legend className="visually-hidden">Subscription Plans</legend>

              {/* Trial card, now always rendered but greyed out if canTrial===false */}
              <div
                className={`plan-option${!canTrial ? ' disabled' : ''}`}
              >
                <label>
                  <input
                    type="radio"
                    name="plan"
                    value="trial"
                    checked={selectedPlan === 'trial'}
                    onChange={handlePlanChange}
                    disabled={!canTrial}
                  />
                  <span className="plan-title">Trial (Free)</span>
                </label>
                <p className="plan-details">
                  1 week access, 1 location, 1 date.
                </p>
                {!canTrial && (
                  <p className="plan-disabled-text">Trial already used</p>
                )}
              </div>

              <div className="plan-option">
                <label>
                  <input
                    type="radio"
                    name="plan"
                    value="essentials"
                    checked={selectedPlan === 'essentials'}
                    onChange={handlePlanChange}
                  />
                  <span className="plan-title">Essentials ($10 per use)</span>
                </label>
                <p className="plan-details">1 location, any date.</p>
              </div>

              <div className="plan-option">
                <label>
                  <input
                    type="radio"
                    name="plan"
                    value="standard"
                    checked={selectedPlan === 'standard'}
                    onChange={handlePlanChange}
                  />
                  <span className="plan-title">Standard ($50 monthly)</span>
                </label>
                <p className="plan-details">Any location, any date.</p>
              </div>

              <div className="plan-option">
                <label>
                  <input
                    type="radio"
                    name="plan"
                    value="premium"
                    checked={selectedPlan === 'premium'}
                    onChange={handlePlanChange}
                  />
                  <span className="plan-title">Premium ($520 yearly)</span>
                </label>
                <p className="plan-details">Any location, any date.</p>
              </div>
            </fieldset>

            <button
              type="button"
              className="big-button"
              onClick={handleCheckout}
            >
              Proceed to Payment
            </button>
            <button
              type="button"
              className="small-button"
              onClick={() => navigate('/signin')}
            >
              Cancel
            </button>
          </form>
        </main>
      </div>
    </>
  );
}